<template>
    <div>
        <h2>{{dictionaries.globalContactHeadline}}</h2>
        <div class="filter-section" v-if="products.length > 0">
            <div class="filter-items">
                <div class="filter-item filter-item--mw" v-if="products.length > 0 && countries.length > 0">
                    <p class="filter-item filter-item__text">{{dictionaries.globalContactFilterLabel}}</p>
                </div>
                <div class="filter-item filter-item--mw" v-if="products.length > 0">
                    <label for="productSelect" class="sr-only">{{dictionaries.globalContactFilterProductLabel}}</label>
                    <select @change="filterChanged(true)" name="productSelect" :disabled="isLoading" v-model="product" class="filter-item__select">
                        <option value="All">{{dictionaries.globalContactFilterProductLabel}}</option>
                        <option :value="product.key" v-for="(product, index) in products" v-if="product.name">{{product.name}}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="products.length > 0 && countries.length > 0">
                    <label for="countrySelect" class="sr-only">{{dictionaries.globalContactFilterCountryLabel}}</label>
                    <select @change="filterChanged(false)" name="countrySelect" :disabled="isLoading" v-model="country" class="filter-item__select">
                        <option value="All">{{dictionaries.globalContactFilterCountryLabel}}</option>
                        <option :value="country.key" v-for="(country, index) in countries" v-if="country.name">{{country.name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <ul class="employee-items" v-show="employees.length">
            <Employee v-for="employee in employees" :employee="employee" :key="employee.id"></Employee>
        </ul>
    </div>
</template>

<script>
    import Employee from "./components/employee.vue";
    import { bindRoute } from "./mixins/bindroute.js";

    const serviceUrl = "/umbraco/api/GlobalContactApi/getcontacts",
        defaultProduct = "All",
        defaultCountry = "All";
    export default {
        name: "globalcontact",
        components: {
            Employee
        },
        data() {
            return {
                dictionaries: [],
                products: [],
                countries: [],
                employees: [],
                isLoading: false
            };
        },
        created() {
            this.getInitialContacts();
        },
        mixins: [
            bindRoute({
                product: defaultProduct,
                country: defaultCountry
            })
        ],
        methods: {
            getEmployees() {
                var vm = this,
                    languageCode = $("html").attr("lang");

                vm.toggleSpinner(true);
                var object = {
                    languageCode: languageCode
                };
                if (this.product != defaultProduct) {
                    object.product = this.product;
                }
                if (this.country != defaultCountry) {
                    object.country = this.country;
                }
                $.get(serviceUrl, object, function (response) {
                    vm.dictionaries = response.dictionaries;
                    vm.products = response.facets.products;
                    vm.countries = response.facets.countries;
                 
                    if (response.items != null) {
                    vm.employees.push(...response.items);
                    }
                }).fail(function (error) {
                    console.log(error);
                }).always(function () {
                    vm.toggleSpinner(false);
                });
            },
            getInitialContacts() {
                // Get all cases up to, and including, the current page
                this.getEmployees();
            },
            toggleSpinner: function (isLoading) {
                this.isLoading = isLoading;
                if (isLoading) {
                    $("body").addClass("is-loading");
                } else {
                    $("body").removeClass("is-loading");
                }
            },
            filterChanged(clearOtherFilters) {
                if (clearOtherFilters) {
                    this.country = defaultCountry;
                }
                this.employees = [];
                this.getEmployees();
            },
            resetFilter() {
                this.employees = [];
                this.product = defaultProduct;
                this.country = defaultCountry;
                this.getEmployees();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/scripts/vue/globalcontact.vue